import React from 'react';
import { RefreshCw, Trash2, Users, Loader2 } from 'lucide-react';

const KioskManagementControls = ({ 
  onDeleteAllImages, 
  onRefreshPages, 
  processing,
  onShowNamesList
}) => {
  return (
    <div className="dropdown-container">
      <button className="dropdown-toggle">
        <RefreshCw size={16} />
        Kiosk Management
      </button>
      <div className="dropdown-menu">
        <button
          className="dropdown-item"
          onClick={onDeleteAllImages}
        >
          <Trash2 size={16} /> Clear PHOTOS & VIDEOS
        </button>
        <button
          className="dropdown-item"
          onClick={onRefreshPages}
          disabled={processing}
        >
          {processing ? (
            <Loader2 className="spin" size={16} />
          ) : (
            <RefreshCw size={16} />
          )}
          Refresh Pages
        </button>
        <button
          className="dropdown-item"
          onClick={onShowNamesList}
        >
          <Users size={16} /> View Names List
        </button>
      </div>
    </div>
  );
};

export default KioskManagementControls;